module.exports = __webpack_public_path__ + "static/media/instagram.d96cf0b7.svg";